/* eslint-disable @typescript-eslint/no-explicit-any */
import { DoesFilterPassParams } from 'ag-grid-community';

export const BLANK_TOKEN = '__BLANK__';

// Normalize any value into a string key (stable & reversible)
export function normalize(val: any): string {
  if (val === null || val === undefined || val === '') return BLANK_TOKEN;
  try {
    return JSON.stringify(val);
  } catch {
    return JSON.stringify(String(val));
  }
}

export function customSetFilterDoesFilterPass({
  model,
  node,
  handlerParams,
}: DoesFilterPassParams<any, any, { values: Set<string> }>): boolean {
  if (model.values == null) {
    return true;
  }
  return model.values.has(normalize(handlerParams.getValue(node)));
}
